import { Extension } from "@tiptap/core";

export type CollapseOptions = {
  types: string[];
};

export const BLOCK_COLLAPSE_TYPES = [
  "paragraph",
  "blockquote",
  "callout",
  "bulletList",
  "orderedList",
  "taskList",
  "image",
  "graph",
  "plotlyChart",
  "embed",
  "fileAttachment",
  "table",
  "codeBlock",
] as const;

export const SECTION_COLLAPSE_TYPES = ["heading", "horizontalRule"] as const;

export const COLLAPSIBLE_TYPES = [...BLOCK_COLLAPSE_TYPES, ...SECTION_COLLAPSE_TYPES];

export type CollapseType = "block" | "section";
export type BlockCollapseType = (typeof BLOCK_COLLAPSE_TYPES)[number];
export type SectionCollapseType = (typeof SECTION_COLLAPSE_TYPES)[number];
export type CollapsibleType = BlockCollapseType | SectionCollapseType;

export const Collapse = Extension.create<CollapseOptions>({
  name: "collapse",

  addOptions() {
    return {
      types: COLLAPSIBLE_TYPES,
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          collapsed: {
            default: false,
            keepOnSplit: false,
            parseHTML: (element) => element.dataset.collapsed === "true",
            renderHTML: ({ collapsed }: { collapsed?: boolean }) => {
              if (!collapsed) {
                return {};
              }

              return { "data-collapsed": "true" };
            },
          },
        },
      },
    ];
  },
});
